"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Password = exports.ItemPasswordStrength = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2, _templateObject3;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  margin-bottom: 15px;\n  .divPasswordStrength {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 30px;\n    & + * {\n      margin-top: 40px;\n    }\n  }\n  label {\n    color: red;\n    margin-top: 3px;\n    margin-left: 15px;\n    font-family: ", ";\n    font-size: 11px;\n  }\n  & + * {\n    margin-top: 20px;\n  }\n"])), _variables.FontFamily.Raleway_700);

exports.Container = Container;

var Password = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: 8px;\n  width: 100%;\n  background-color: ", ";\n"])), function (props) {
  switch (props.passwordStrength) {
    case 0:
      return "#F0F0F0";

    case 1:
      if (props.level === 1) {
        return "#E67432";
      } else {
        return "#F0F0F0";
      }

    case 2:
      if (props.level <= 2) {
        return "#EDD34D";
      } else {
        return "#F0F0F0";
      }

    case 3:
      if (props.level <= 3) {
        return "#71DE56";
      } else {
        return "#F0F0F0";
      }

    case 4:
      if (props.level <= 4) {
        return "#71DE56";
      } else {
        return "#F0F0F0";
      }

    default:
      return;
  }
});

exports.Password = Password;

var ItemPasswordStrength = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 24%;\n  position: relative;\n  p {\n    margin-top: 1.5%;\n    font-weight: 700;\n    display: flex;\n    justify-content: flex-end;\n    font-size: 11px;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    color: ", ";\n  }\n"])), function (props) {
  switch (props.paso) {
    case 1:
      return "#E67432";

    case 2:
      return "#EDD34D";

    case 3:
      return "#71DE56";

    case 4:
      return "#71DE56";
  }
});

exports.ItemPasswordStrength = ItemPasswordStrength;